import React from 'react';

export function TaskFilter({ taskFilter, setTaskFilter }) {
  return (
    <>
      <div className="task-filter">
        <span className="task-filter-label">Filtre :</span>

        <button
          type="button"
          className={taskFilter === 'all' ? 'task-filter-btn active' : 'task-filter-btn'}
          onClick={() => setTaskFilter('all')}
        >
          Tous
        </button>

        <button
          type="button"
          className={taskFilter === 'leroy' ? 'task-filter-btn active' : 'task-filter-btn'}
          onClick={() => setTaskFilter('leroy')}
        >
          Leroy Merlin
        </button>

        <button
          type="button"
          className={taskFilter === 'R' ? 'task-filter-btn active' : 'task-filter-btn'}
          onClick={() => setTaskFilter('R')}
        >
          (R)
        </button>

        <button
          type="button"
          className={taskFilter === 'P' ? 'task-filter-btn active' : 'task-filter-btn'}
          onClick={() => setTaskFilter('P')}
        >
          (P)
        </button>

        <button
          type="button"
          className={taskFilter === 'RP' ? 'task-filter-btn active' : 'task-filter-btn'}
          onClick={() => setTaskFilter('RP')}
        >
          (R + P)
        </button>
      </div>

      {taskFilter !== 'all' && (
        <div className="task-filter-hint">
          Filtre actif : glisser/déposer désactivé (affichage uniquement)
        </div>
      )}
    </>
  );
}
